import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { CycleValidationDTO } from 'src/app/shared/dtos/cycleValidationDTO';

@Component({
  selector: 'app-cycle-validation-list',
  templateUrl: './cycle-validation-list.component.html',
  styleUrls: ['./cycle-validation-list.component.scss']
})
export class CycleValidationListComponent implements OnChanges {

  @Input() cyclesValidation: CycleValidationDTO[]

  displayedColumnsBC: string[] = ['Etape initiale','Etape finale', 'Qui', 'Quand', 'Commentaire']
  matDataSourceBC: MatTableDataSource<CycleValidationDTO> = new MatTableDataSource<CycleValidationDTO>();

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.cyclesValidation.forEach(cycle => {
      var index = cycle.usersStandard.findIndex(user => user.id === 1);
      if(index !== -1) {
        cycle.usersStandard.splice(index, 1);
      }
      index = cycle.usersDeleg.findIndex(user => user.id === 1);
      if(index !== -1) {
        cycle.usersDeleg.splice(index, 1);
      }
    });
    this.matDataSourceBC = new MatTableDataSource(this.cyclesValidation);
  }
}
